<template>
  <div>
   
    <autoLogout />
    <loader :loader="sending" />
    <div class="wrapper-content">
      <encabezado :elementos="encabezado" />s
      <v-card>
        <div class="container">
          <v-subheader>Información del Rol</v-subheader>
          <v-divider class="mb-5"></v-divider>
          <br />

          <v-form ref="form" v-model="valid" lazy-validation>
            <v-row align="center"
              ><v-col cols="4"
                ><v-text-field
                  prepend-icon="mdi-account"
                  v-model="roleName"
                  :value="roleName"
                  :rules="roleNameRules"
                  label="Nombre del Rol"
                  id="roleName"
                  required
                ></v-text-field
              ></v-col>
              <v-col cols="6">
                <v-text-field
                  prepend-icon="mdi-note-text"
                  v-model="roleDescription"
                  :value="roleDescription"
                  :rules="roleDescriptionRules"
                  label="Descripción del Rol"
                  id="roleDescription"
                  required
                ></v-text-field>
              </v-col>
            </v-row>
          </v-form>
          <br />
          <v-subheader>Permisos del Rol</v-subheader>
          <v-divider class="mb-5"></v-divider>
          <div v-show="true">
            <!-- v-model="objAddDate.idPatient" -->
            <!-- {{modelModule}} -->
            <div class="row">
              <div class="col-md-4">
                <!-- @change="loadPermissions" -->

                <v-autocomplete
                  :items="modules"
                  v-model="modelModule"
                  label="Módulo"
                  prepend-icon="mdi-account"
                  required
                  no-data-text="Sin resultados disponibles"
                  clearable
                  auto-select-first
                ></v-autocomplete>
              </div>
              <div class="col-md-8">
                <div class="row">
                  <div class="col-md-10">
                    <v-text-field
                      v-model="searchPermission"
                      append-icon="mdi-magnify"
                      label="Buscar"
                      single-line
                      hide-details
                      class="mx-5 mb-3"
                    />
                  </div>
                  <div class="col-md-2">
                    <v-switch
                      :disabled="
                        sending ||
                        modelModule == null ||
                        !modelModule.permissions
                      "
                      label="Todo"
                      v-model="all"
                      @click="setAllPermissions"
                      hide-details
                    ></v-switch>
                  </div>
                </div>

                {{ modelModule.permission }}
                <v-data-table
                  :headers="headersPermissions"
                  :items="modelModule != null ? modelModule.permissions : []"
                  :search="searchPermission"
                  :items-per-page="10"
                  :footer-props="{
                    'items-per-page-text': 'Elementos por página',
                    'items-per-page-all-text': 'Todo',
                  }"
                  no-results-text="Sin resultados coincidentes con el búsqueda"
                  loading-text="Cargando..."
                  no-data-text="Sin resultados disponibles"
                  class="mx-5"
                  dense
                  fixed-header
                  height="auto"
                >
                  <template v-slot:[`item.description`]="{ item }">
                    <span
                      :class="{
                        'font-italic font-weight-bold': item.type == 2,
                      }"
                    >
                      {{ item.description }}
                    </span>
                  </template>
                  <template v-slot:[`item.actions`]="{ item }">
                    <!-- <v-tooltip top>
                          <template v-slot:activator="{ on, attrs }"> -->

                    <v-checkbox
                      v-model="item.assign"
                      hide-details
                      dense
                      @click="modificar()"
                      :disabled="sending"
                    />
                    <!-- <v-checkbox v-model="item.assign"  v-bind="attrs" v-on="on" :disabled="sending"/>  -->
                    <!-- </template>
                          <span>Asignar {{item.idPermission}}</span>
                        </v-tooltip>                          -->
                  </template>
                </v-data-table>
              </div>
            </div>
            <div class="d-flex justify-center">
              <v-col class="d-flex justify-space-around">
                <v-btn
                  type="button"
                  color="error"
                  @click="backRoute"
                  :disabled="sending"
                >
                  <v-icon left>mdi-close</v-icon>
                  Volver
                </v-btn>
                <v-btn
                  type="button"
                  :disabled="sending"
                  color="success"
                  @click="guardarRol()"
                >
                  <v-icon left>mdi-content-save</v-icon>
                  Guardar
                </v-btn>
              </v-col>
            </div>
          </div>

          <div v-show="false">
            <br />
            <v-row>
              <v-text-field
                v-model="search"
                append-icon="mdi-magnify"
                label="Buscar"
                single-line
                hide-details
                class="mx-5 mb-3"
              ></v-text-field>
              <v-col cols="2"></v-col>
              <v-col cols="1" v-if="edit" @click="guardarRol()">
                <btn-accion :elements="btnEdit" />
              </v-col>
              <v-col cols="1" v-if="!edit" @click="statusOk()">
                <btn-accion :elements="btnEdit2" />
              </v-col>
              <v-col cols="3"></v-col>
            </v-row>
            <br />
            <v-row align="center">
              <div class="col-md-2" v-for="post in filteredList" :key="post.id">
                <v-checkbox
                  v-model="permission[`${post.idPermission - 1}`]"
                  :disabled="sending"
                  @click="modificar(post.idPermission)"
                ></v-checkbox>
              </div>
            </v-row>
            <v-btn
              v-scroll="onScroll"
              v-show="fab"
              fab
              dark
              fixed
              bottom
              right
              color="primary"
              @click="toTop"
            >
              <v-icon>mdi-arrow-up</v-icon>
            </v-btn>
          </div>
        </div>
        <v-dialog v-model="dialog" persistent max-width="450">
          <v-card>
            <v-card-title class="text-h6 text-center">
              ¿Desea registrar este Rol?
            </v-card-title>
            <v-card-text
              >El Rol será accesible por otros usuarios para su asignación o
              modificación</v-card-text
            >
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="error" text @click="dialog = false">
                Cancelar
              </v-btn>
              <v-btn
                :disabled="!valid"
                color="primary"
                text
                @click="registrar()"
              >
                Aceptar
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-card>
    </div>
  </div>
</template>
<script>
import moment from "moment";
import Datatable from "../../components/Datatable.vue";
import Encabezado from "@/app/components/base/header/Header.vue";
import Sidebar from "../../components/Sidebar";
import BtnAccion from "../../components/btnAccion.vue";
import { RolePermissionRequest, ModuleRequest } from "@/core/request";
import { mapActions } from "vuex";
import AutoLogout from "../../components/AutoLogout.vue";
import Loader from "../../components/Loader.vue";

export default {
  name: "Estudio",
  components: {
    Sidebar,
    Encabezado,
    Datatable,
    BtnAccion,
    AutoLogout,
    Loader,
  },
  data: () => ({
    fab: false,
    search: "",
    roleName: "",
    roleDescription: "",
    idRole: "",
    sending: true,
    dialog: false,
    edit: true,
    permisos: [],
    valid: true,
    prevent: 0,
    encabezado: { icono: "mdi-account-multiple-plus", texto: "Registrar Rol" },
    list: [],
    listPermissions: [],
    permission: [],
    modelModule: {},
    serviceModule: ModuleRequest,
    headersPermissions: [
      { text: "Id Permiso", value: "idPermission" },
      { text: "Nombre", value: "description" },
      { text: "Asignar", value: "actions", sortable: false },
    ],
    searchPermission: "",
    prevent: 0,
    modules: [],
    all: false,
    btnEdit: {
      icon: "mdi-account-check",
      text: "Guardar Rol",
      tooltip: "Guardar Rol",
    },
    btnEdit2: {
      icon: "mdi-key-remove",
      text: "Guardar Permisos",
      tooltip: "Guardar permisos",
      color: "success",
    },
    service: RolePermissionRequest,
    roleNameRules: [(v) => !!v || "El nombre del rol es obligatorio"],
    roleDescriptionRules: [
      (v) => !!v || "La descripción del rol es obligatoria",
    ],
  }),
  beforeMount() {},
  mounted() {
    this.validBrowserTab();
    this.getPermissions();
    this.listAllWithPermissions();
  },
  watch: {
    modelModule: function (newVal, oldVal) {
      if (newVal != null) {
        this.updateAll();
      }
    },
  },
  modificar(id) {
    this.sending = true;
    let postData = {
      permission: {
        idPermission: id,
      },
    };
    this.permisos.push(postData);
  },
  updated() {
    if (this.prevent == 0) {
      this.permission.push(true, true, true);
      this.prevent++;
    }
  },
  methods: {
    ...mapActions(["validTab", "unauthorized"]),
    validBrowserTab() {
      this.validTab();
    },
    backRoute() {
      this.sending = true;
      this.$router.go(-1);
    },
    catchError: (e) => {},
    onScroll(e) {
      if (typeof window === "undefined") return;
      const top = window.pageYOffset || e.target.scrollTop || 0;
      this.fab = top > 200;
    },
    toTop() {
      this.$vuetify.goTo(0);
    },
    updateAll() {
      this.all = false;
      let filtered = this.modelModule.permissions.filter(function (it) {
        return it.assign == true;
      });
      this.all =
        filtered.length == this.modelModule.permissions.length &&
        this.modelModule.permissions.length > 0;
    },
    setAllPermissions() {
      if (this.modelModule && this.modelModule.permissions) {
        this.modelModule.permissions = this.modelModule.permissions.map(
          (it) => {
            it.assign = this.all;
            return it;
          }
        );
      }
    },
    getPermissions() {
      RolePermissionRequest.getPermissions().then((res) => {
        if (res.data.code === 200 && res.data.status === "OK") {
          this.sending = false;
          this.list = res.data.data.map((permission) => {
            return {
              idPermission: permission.idPermission,
              description: permission.description,
            };
          });
        } else if (res.data.code === 401) {
          this.unauthorized();
          this.sending = false;
        }
        this.sending = false;
      });
    },
    listAllWithPermissions() {
      let id = localStorage.getItem("idRole");
      this.modules = [];
      this.serviceModule.listAllWithPermissions().then((res) => {
        let { data, response, message } = res.data;
        if (response) {
          this.modules = data.map((it) => {
            return { text: it.name, value: it };
          });
          this.modelModule = this.modules[0].value;
        }
      });
    },
    guardarRol() {
      this.dialog = true;
      /*
      for (let i = 0; i < this.permission.length; i++) {
        if (this.permission[i] == null) {
          this.permission[i] = false;
        }
      }
      if (this.$refs.form.validate()) {
      }
      */
    },
    registrar() {
      if(!this.sending){
      this.dialog = false;

      this.sending = true;
      let permissionsList = [];
      for (let i = 0; i < this.modules.length; i++) {
        permissionsList = permissionsList.concat(
          this.modules[i].value.permissions
        );
      }
      permissionsList = permissionsList.map((prm) => {
        return { idPermission: prm.idPermission, assign: prm.assign };
      });

      let postData = {
        role: {
          name: this.roleName.trim(),
          description: this.roleDescription,
        },
        permissions: permissionsList,
      };

      RolePermissionRequest.addRole(postData).then((res) => {
        let { data, response, message } = res.data;
        if (response === true) {
          this.$utilFront.notifications(
            "Rol registrado correctamente",
            "SUCCESS"
          );
          this.$router.push("/configuracion/roles");
        } else if (res.data.code === 401) {
          this.unauthorized();
        } else {
          message = message || "Rol registrado sin permisos";
          this.$utilFront.notifications(message, "ERROR");
        }
      }).finally(() => {
        this.sending = false;
      });
      }
    },
  },
  computed: {
    filteredList() {
      return this.list.filter((post) => {
        return post.description
          .toLowerCase()
          .includes(this.search.toLowerCase());
      });
    },
  },
};
</script>